// @flow
type SearchTermInitActionType = 'SEARCH_TERM/INIT';
export type SearchTermType = {
    description: string,
    id: string
};
export type ActionType = SearchTermInitActionType;
export type SearchTermInitAction = {
    type: ActionType,
    payload: SearchTermType
};

export type Action = SearchTermInitAction;

export const SEARCH_TERM_INIT = 'SEARCH_TERM/INIT';

const ACTION_CREATORS = {
    initSearchTerm(searchTerm: SearchTermType): SearchTermInitAction {
        return {type: SEARCH_TERM_INIT, payload: searchTerm};
    }
};

export default {
    ...ACTION_CREATORS
};
